var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTesting = function SvgIconTesting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_testing_svg2__a",
    x1: 61.93,
    x2: 347.13,
    y1: 433.17,
    y2: 55.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__b",
    x1: 26.31,
    x2: 311.51,
    y1: 406.25,
    y2: 28.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__c",
    x1: -17.44,
    x2: 267.77,
    y1: 373.2,
    y2: -4.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__d",
    x1: 14.08,
    x2: 299.29,
    y1: 397.01,
    y2: 19.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__e",
    x1: 213.26,
    x2: 498.47,
    y1: 547.51,
    y2: 170.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__f",
    x1: 84.68,
    x2: 369.88,
    y1: 450.35,
    y2: 72.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__g",
    x1: 203.56,
    x2: 488.76,
    y1: 540.18,
    y2: 162.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__h",
    x1: 49.9,
    x2: 335.1,
    y1: 424.07,
    y2: 46.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_testing_svg2__a",
    id: "icon_testing_svg2__i",
    x1: 49.89,
    x2: 335.1,
    y1: 424.07,
    y2: 46.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M283.15 487.25H135.78c-16.76 0-30.39-13.63-30.39-30.39v-1.81H221.8c9.33 0 16.92-7.59 16.92-16.92V293.32c0-9.33-7.59-16.92-16.92-16.92H105.39V43.14c0-16.76 13.63-30.39 30.39-30.39h30.61c3.52 0 6.37-2.85 6.37-6.37S169.91.01 166.39.01h-30.61c-23.79 0-43.14 19.35-43.14 43.14V276.4H76.98c-9.33 0-16.92 7.59-16.92 16.92v22.98c0 3.52 2.85 6.37 6.37 6.37s6.37-2.85 6.37-6.37v-22.98c0-2.3 1.87-4.18 4.18-4.18h144.81c2.3 0 4.18 1.87 4.18 4.18v144.81c0 2.3-1.87 4.18-4.18 4.18H76.98c-2.3 0-4.18-1.87-4.18-4.18v-87.52c0-3.52-2.85-6.37-6.37-6.37s-6.37 2.85-6.37 6.37v87.52c0 9.33 7.59 16.92 16.92 16.92h15.66v1.81c0 23.79 19.35 43.14 43.14 43.14h147.37c3.52 0 6.37-2.85 6.37-6.37s-2.85-6.37-6.37-6.37Z",
    style: {
      fill: "url(#icon_testing_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.7 12.75h163.53c16.76 0 30.39 13.63 30.39 30.39v36.29c0 3.52 2.85 6.37 6.37 6.37s6.37-2.85 6.37-6.37V43.14C407.36 19.35 388.01 0 364.22 0H200.69c-3.52 0-6.37 2.85-6.37 6.37s2.85 6.37 6.37 6.37Z",
    style: {
      fill: "url(#icon_testing_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.99 29.41c-3.52 0-6.37 2.85-6.37 6.37s2.85 6.37 6.37 6.37h49.02c3.52 0 6.37-2.85 6.37-6.37s-2.85-6.37-6.37-6.37z",
    style: {
      fill: "url(#icon_testing_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.31 32.25c-.23-.35-.5-.68-.79-.97-1.19-1.19-2.83-1.87-4.51-1.87s-3.31.69-4.5 1.87c-.29.29-.57.62-.79.97-.24.34-.43.72-.59 1.1s-.28.78-.36 1.19c-.09.41-.13.83-.13 1.25 0 1.68.69 3.32 1.87 4.51s2.82 1.87 4.5 1.87 3.32-.69 4.51-1.87 1.86-2.83 1.86-4.51c0-.41-.04-.83-.12-1.25-.09-.4-.21-.8-.37-1.19-.16-.38-.35-.75-.58-1.1",
    style: {
      fill: "url(#icon_testing_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.02 276.39h-15.66V113.75c0-3.52-2.85-6.37-6.37-6.37s-6.37 2.85-6.37 6.37V276.4H278.21c-9.33 0-16.92 7.59-16.92 16.92v144.81c0 9.33 7.59 16.92 16.92 16.92h116.41v1.81c0 16.76-13.63 30.39-30.39 30.39h-46.76c-3.52 0-6.37 2.85-6.37 6.37s2.85 6.37 6.37 6.37h46.76c23.79 0 43.14-19.35 43.14-43.14v-1.81h15.66c9.33 0 16.92-7.59 16.92-16.92V293.31c0-9.33-7.59-16.92-16.92-16.92Zm4.18 161.74c0 2.3-1.87 4.18-4.18 4.18H278.21c-2.3 0-4.18-1.87-4.18-4.18V293.32c0-2.3 1.87-4.18 4.18-4.18h144.81c2.3 0 4.18 1.87 4.18 4.18z",
    style: {
      fill: "url(#icon_testing_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.18 329.04c0-5.11-1.99-9.91-5.6-13.52s-8.41-5.6-13.52-5.6-9.91 1.99-13.52 5.6l-22.16 22.16-22.16-22.16c-3.61-3.61-8.41-5.6-13.52-5.6s-9.91 1.99-13.52 5.6-5.6 8.41-5.6 13.52 1.99 9.91 5.6 13.52l22.16 22.16-22.16 22.16c-7.45 7.45-7.45 19.58 0 27.04 3.61 3.61 8.41 5.6 13.52 5.6s9.91-1.99 13.52-5.6l22.16-22.16 22.16 22.16c3.61 3.61 8.41 5.6 13.52 5.6s9.91-1.99 13.52-5.6c7.45-7.45 7.45-19.58 0-27.04l-22.16-22.16 22.16-22.16c3.61-3.61 5.6-8.41 5.6-13.52m-14.61 4.5-26.67 26.67a6.367 6.367 0 0 0 0 9.01l26.67 26.67c2.48 2.48 2.48 6.53 0 9.01-1.2 1.2-2.8 1.87-4.5 1.87s-3.3-.66-4.51-1.87l-26.67-26.67a6.38 6.38 0 0 0-9.02 0L118.2 404.9c-1.2 1.2-2.8 1.87-4.5 1.87s-3.3-.66-4.51-1.87c-2.48-2.49-2.48-6.53 0-9.01l26.67-26.67a6.367 6.367 0 0 0 0-9.01l-26.67-26.67c-1.2-1.2-1.87-2.8-1.87-4.51s.66-3.3 1.87-4.51c1.2-1.2 2.8-1.87 4.51-1.87s3.3.66 4.51 1.87l26.67 26.67a6.367 6.367 0 0 0 9.01 0l26.67-26.67c1.2-1.2 2.8-1.87 4.51-1.87s3.3.66 4.51 1.87c1.2 1.2 1.87 2.8 1.87 4.51s-.66 3.3-1.87 4.51Z",
    style: {
      fill: "url(#icon_testing_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.18 313.96a18.98 18.98 0 0 0-14.1-3.89c-5.07.63-9.59 3.19-12.73 7.22l-41.48 53.23-18.78-21.14c-7-7.88-19.1-8.6-26.99-1.6a18.98 18.98 0 0 0-6.39 13.16c-.3 5.1 1.4 10.01 4.79 13.83l34.03 38.32a19.15 19.15 0 0 0 14.29 6.42c.21 0 .42 0 .61-.01 5.69-.18 10.97-2.87 14.47-7.36l55.6-71.35c3.14-4.03 4.52-9.04 3.89-14.11s-3.19-9.59-7.22-12.73Zm-6.73 19-55.6 71.36a6.35 6.35 0 0 1-4.84 2.45h-.19c-1.82 0-3.56-.78-4.76-2.14l-34.03-38.32c-1.13-1.27-1.7-2.91-1.6-4.61s.86-3.26 2.13-4.39a6.32 6.32 0 0 1 4.23-1.6c1.76 0 3.51.72 4.77 2.14l23.86 26.87a6.4 6.4 0 0 0 4.97 2.14 6.37 6.37 0 0 0 4.82-2.45l46.19-59.27a6.35 6.35 0 0 1 4.24-2.41c1.69-.21 3.36.25 4.7 1.3a6.35 6.35 0 0 1 2.41 4.24c.21 1.69-.25 3.36-1.3 4.7Z",
    style: {
      fill: "url(#icon_testing_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.07 114.27 5.49 7.1c-1.83 3.64-3.4 7.42-4.68 11.28l-8.9 1.14c-4.63.59-8.13 4.57-8.13 9.24v32.39c0 4.67 3.49 8.64 8.13 9.24l8.9 1.14c1.28 3.86 2.85 7.64 4.68 11.28l-5.49 7.1c-2.86 3.7-2.52 8.98.78 12.28l22.91 22.91c3.3 3.3 8.58 3.64 12.28.78l7.1-5.49c3.64 1.83 7.42 3.4 11.28 4.68l1.14 8.9c.6 4.63 4.57 8.13 9.24 8.13h32.39c4.67 0 8.64-3.49 9.24-8.13l1.14-8.9c3.86-1.28 7.64-2.85 11.28-4.68l7.1 5.49c3.7 2.86 8.98 2.52 12.28-.78l22.91-22.91c3.3-3.3 3.64-8.58.78-12.28l-5.49-7.1c1.83-3.64 3.4-7.42 4.68-11.28l8.91-1.14c4.63-.6 8.12-4.57 8.12-9.24v-32.39c0-4.67-3.49-8.64-8.13-9.24l-8.9-1.14a84 84 0 0 0-4.68-11.28l5.49-7.1c2.86-3.7 2.52-8.98-.78-12.28l-22.91-22.91c-3.3-3.3-8.58-3.64-12.28-.78l-7.1 5.49c-3.64-1.83-7.42-3.4-11.28-4.68l-1.14-8.9c-.6-4.63-4.57-8.13-9.24-8.13H233.8c-4.67 0-8.64 3.49-9.24 8.13l-1.14 8.9a84 84 0 0 0-11.28 4.68l-7.1-5.49c-3.7-2.86-8.98-2.52-12.28.78l-22.9 22.91c-3.3 3.3-3.64 8.58-.78 12.28Zm16.92 1.05-4.98-6.45 18.64-18.64 6.45 4.98c2.9 2.24 6.87 2.56 10.12.82 4.14-2.22 8.52-4.03 13-5.39a9.35 9.35 0 0 0 6.58-7.74l1.04-8.08h26.35l1.04 8.08c.46 3.63 3.04 6.67 6.57 7.74 4.49 1.36 8.86 3.17 13 5.39 3.25 1.74 7.22 1.42 10.12-.82l6.45-4.98 18.64 18.64-4.99 6.45c-2.24 2.9-2.56 6.87-.82 10.12 2.22 4.14 4.03 8.52 5.39 13 1.07 3.53 4.1 6.11 7.74 6.57l8.08 1.04v26.36l-8.08 1.04a9.36 9.36 0 0 0-7.74 6.57 71.6 71.6 0 0 1-5.39 13c-1.74 3.25-1.42 7.22.82 10.12l4.98 6.45-18.64 18.64-6.45-4.99c-2.9-2.24-6.87-2.56-10.12-.82a71.6 71.6 0 0 1-13 5.39c-3.53 1.07-6.11 4.1-6.57 7.74l-1.04 8.08h-26.35l-1.04-8.08a9.35 9.35 0 0 0-6.57-7.73 71.3 71.3 0 0 1-13-5.39c-3.25-1.74-7.22-1.42-10.12.82l-6.45 4.98-18.64-18.64 4.99-6.45c2.24-2.9 2.56-6.87.82-10.12a71.3 71.3 0 0 1-5.39-13c-1.07-3.53-4.1-6.11-7.74-6.57l-8.08-1.04v-26.36l8.08-1.04c3.63-.47 6.67-3.05 7.74-6.57 1.36-4.49 3.17-8.86 5.39-13 1.74-3.25 1.42-7.22-.82-10.12Z",
    style: {
      fill: "url(#icon_testing_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 215.9c31.25 0 56.67-25.42 56.67-56.67s-25.42-56.67-56.67-56.67-56.67 25.42-56.67 56.67S218.75 215.9 250 215.9m0-100.6c24.22 0 43.93 19.71 43.93 43.93s-19.71 43.93-43.93 43.93-43.93-19.71-43.93-43.93S225.78 115.3 250 115.3",
    style: {
      fill: "url(#icon_testing_svg2__i)"
    }
  }));
};
export default SvgIconTesting;